<template>
  <div :class="classes">
      <pt-page-title :title="(isIntegralpolicy?'积分商品':'')+'政策规则管理'">
          <el-button slot="before-left" type="primary" @click="createdPolicyManage">新建{{isIntegralpolicy?'积分商品':""}}政策规则</el-button>
      </pt-page-title>
      <pt-page-menu-filter :tabs="policyTabs" v-model="selectTab" @fromRouter="fromRouter"></pt-page-menu-filter>
      <pt-policy-table :tableLabels="policyTableLabel" :page-size="10" :isFromRouter="isFromRouter" :selectTab="selectTab" ref="table">
          <el-table-column label="操作">
                <template slot-scope="scope">
                  <i class="iconfont icon-xiangqing" @click="policyDetail(scope.row)"></i>
                  <i class="iconfont icon-dingdanchuangjian" @click="editPolicy(scope.row)"></i>
                  <i class="iconfont icon-shanchu" @click="deletePolicy(scope.row)"></i>
              </template>
          </el-table-column>
      </pt-policy-table>
  </div>
</template>

<script>
// 组件class前缀
import { policyTabs, policyTableLabel } from './policy-manage.js'
import ptPolicyTable from './pt-policy-table/withData.vue'
const prefixCls = 'pt-policy-manage'
export default {
  name: 'pt-policy-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    },
    // 是否积分政策
    isIntegralpolicy () {
      return this.$route.name === 'integral-policy-manage'
    }
  },
  components: {
    ptPolicyTable
  },
  data () {
    return {
      policyTabs: policyTabs,
      selectTab: '',
      policyTableLabel: policyTableLabel,
      isFromRouter: false
    }
  },
  methods: {
    getTableData () {
      this.$refs.table.getTableData(this.page)
    },
    fromRouter (val) {
      this.isFromRouter = val
    },
    createdPolicyManage () {
      let routerUrl = this.isIntegralpolicy ? '/policy-form/' + false + '/false/0/true' : '/policy-form/' + false + '/false/0'
      this.$router.push(routerUrl)
    },
    policyDetail (row) {
      let routerUrl = this.isIntegralpolicy ? '/policy-detail/' + this.selectTab + '/' + row.id + '/true' : '/policy-detail/' + this.selectTab + '/' + row.id
      this.$router.push(routerUrl)
    },
    editPolicy (row) {
      let routerUrl = this.isIntegralpolicy ? '/policy-form/' + this.selectTab + '/true/' + row.id + '/true' : '/policy-form/' + this.selectTab + '/true/' + row.id
      this.$router.push(routerUrl)
    },
    deletePolicy (row) {
      this.$confirm('您确定删除该' + (this.isIntegralpolicy ? '积分商品' : '') + this.policyDelete().name + '?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$emit('deletePolicy', this.policyDelete(), row.id)
      })
    },
    // 根据当前tab判断删除的数据的类型即调用什么接口
    policyDelete () {
      let data = {}
      switch (this.selectTab) {
        case 'afterSales':
          data.apiUrl = this.isIntegralpolicy ? 'deleteIntegralAfterSalesPolicie' : 'afterSalesDelete'
          data.name = '售后政策'
          break
        case 'carriage':
          data.apiUrl = this.isIntegralpolicy ? 'deleteIntegralCarriagePolicie' : 'carriagePolicyDelete'
          data.name = '运费政策'
          break
        case 'privacy':
          data.apiUrl = this.isIntegralpolicy ? 'deletePrivacyPolicies' : 'privacyPolicyDelete'
          data.name = '隐私条款'
          break
        default:
          console.log('未定义类型')
          break
      }
      return data
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-policy-manage{
    i{
        margin-right: 10px;
    }
}
</style>
